import React from 'react';
import Hero from '../sections/Hero';
import About from '../sections/About';
import Work from '../sections/Work';
import Speaking from '../sections/Speaking';
import Writing from '../sections/Writing';
import Book from '../sections/Book';
import Recognition from '../sections/Recognition';

const Home = () => (
  <>
    <Hero />
    <About />
    <Work />
    <Speaking />
    <Writing />
    <Book />
    <Recognition />
  </>
);

export default Home;
